import React from 'react';
import { Content, Flex, Text } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import AbstractMissingRelationshipScreen from "./AbstractMissingRelationshipScreen.js";
import S from './Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class MobileMissingRelationshipScreen extends AbstractMissingRelationshipScreen {
  constructor(props) {
    super(props);
    this.mobile = true;
    this.matchContext.mobile = true;
  }
  componentDidMount() {
    const {
      setTitle,
      setIcon,
      setActionsContext
    } = this.props;
    setTitle({
      data: this.getName()
    });
    setIcon({
      data: this.getIcon()
    });
    setActionsContext({
      data: this.getContext()
    });
  }
  render() {
    return /*#__PURE__*/_jsx(Content, {
      children: /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsxs("div", {
          className: S.mobileContent,
          children: [/*#__PURE__*/_jsx("img", {
            className: S.mobileImage,
            src: this.getImageSource(),
            alt: "noData"
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "col",
            align: "start",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "mobileMissingRelTitle|missingRelTitle",
              children: this.getTitle()
            }), /*#__PURE__*/_jsxs(Text, {
              variant: "mobileMissingRelTitle|missingRelSubtitle",
              children: [this.getSubtitle(), " "]
            }), /*#__PURE__*/_jsx(Toolbar, {
              variant: "mobileMissingRelTitle|missingRel",
              matchContext: {
                ...this.matchContext,
                use: 'missingRel'
              },
              context: this.getContext()
            })]
          })]
        })
      })
    });
  }
}
export default MobileMissingRelationshipScreen;